import React, { useState } from "react";
import HoverButton from "../Components/HoverButton"; // adding hover styling button
import { useTimer } from "react-timer-hook";

function Timer({ expiryTimestamp, handleClick }) {
  const [showResend, setShowResend] = useState(false);
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp,
    onExpire: () => setShowResend(true),
  });

  const handleButtonClick = () => {
    handleClick()
    const time = new Date();
        time.setSeconds(time.getSeconds() + 300);
        restart(time)
        setShowResend(false)
  }
  return (
    <div
      style={{
        fontSize: "8px",
        display: "flex",
        justifyContent: "end",
        flexDirection: "column",
      }}
    >
      <h1>
      <span>Your OTP will expire in </span>
        <span>{`0${minutes}`}</span>:
        <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
        {/* <span>You will able to resend in</span> */}
      </h1>
      {showResend ? (
        <HoverButton
          onClick={handleButtonClick}
          text="Resend OTP"
          iconName="MdOutlineSend"
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default Timer;
